import React, { useEffect, useState } from "react";
import { Button, Form } from "antd";
import { useNavigate, useParams } from "react-router";
import SinglePageContainer from "../../../Common/SinglePageContainer";
import OverviewSection from "./OverviewSection";
import { useMiddahGetById, useMiddahsGet } from "../../../../hooks/api/middot";
import ExercisesTable from "./ExercisesTable";

export default function ExercisesContent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const middahGetById = useMiddahGetById(id);

  console.log(id);
  return (
    <SinglePageContainer
      title={middahGetById.data?.name}
      onBack={() => navigate("/middot-list")}
      noPadding
      transparent
    >
      <OverviewSection data={middahGetById.data} />
      <ExercisesTable />
    </SinglePageContainer>
  );
}
